//  index.js
//  Project hpi
//
//  Created by Axis Maps on 4/7/2020, 11:30:45 AM
//

import Loadable from 'react-loadable';

export default Loadable({
  loader: () => import('./community-conditions.component'),
  loading: () => null,
});
